<template>
    <dl
        class="nutrition-facts"
        :class="{
            'grid-3': !(facts.length % 3),
            'grid-4': facts.length % 3,
        }"
    >
        <div
            v-for="fact in facts"
            :key="fact.title"
            class="fact"
            v-test:fact
        >
            <dt
                class="fact-title"
                :class="{
                    'fact-title--plants': fact.title === 'plant points',
                }"
                v-test:factTitle
            >
                {{ fact.title }}
            </dt>
            <dd
                class="fact-description"
                v-test:factDescription
            >
                {{ formatNumber(fact.description) }}
            </dd>
        </div>
    </dl>
</template>

<script>
    export default {
        name: 'nutrition-facts',

        props: {
            facts: {
                type: Array,
                default: () => ([]),
            },
        },

        methods: {
            /**
             * Format number to max two decimal points.
             *
             * @param {string | number} description
             * @returns {string | number}
             */
            formatNumber(description) {
                if (isNaN(description)) {
                    return description;
                }

                return parseFloat(parseFloat(description).toFixed(2));
            },
        },
    };
</script>

<style lang="scss" scoped>
    .nutrition-facts {
        display: flex;
        flex-wrap: wrap;
        max-width: 480px;
        margin-bottom: 0;
        @include media-breakpoint-up(md) {
            max-width: 650px;
        }
    }

    .grid-3 {
        .fact {
            @include media-breakpoint-up(md) {
                flex-basis: 33.333%;
            }
        }
    }

    .grid-4 {
        .fact {
            @include media-breakpoint-up(md) {
                flex-basis: 25%;
            }
        }
    }

    .fact {
        background-color: secondary-palette(7);
        padding: 10px;
        flex-basis: 50%;
        outline: 2px solid $white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        font-size: 1rem;
        line-height: rem(24px);
        font-weight: 300;
        @include media-breakpoint-up(md) {
            flex-basis: 25%;
        }
    }

    .fact-title {
        font-weight: 300;

        &--plants {
            color: secondary-palette(2);
        }
    }

    .fact-description {
        line-height: rem(20px);
        font-weight: 700;
    }
</style>
